import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import A_TextField from "../../../Atoms/Inputs/TextFields/A_TextField";
import A_Switch from "../../../Atoms/Inputs/Switches/A_Switch";
import IconAction from "./IconAction";
import useStyles from "./ProfessionalContacts.styles";

const ContactRowsEditor = ({ contacts, onChange }) => {
  const classes = useStyles();

  const updateRow = (rowKey, field, value) => {
    onChange(
      contacts.map((row) =>
        row._key === rowKey ? { ...row, [field]: value } : row
      )
    );
  };

  const setMain = (rowKey) => {
    onChange(contacts.map((row) => ({ ...row, isMain: row._key === rowKey })));
  };

  const addRow = () => {
    onChange([
      ...contacts,
      {
        _key: `new-${Date.now()}-${contacts.length}`,
        name: "",
        role: "",
        email: "",
        phone: "",
        isMain: false,
      },
    ]);
  };

  const removeRow = (rowKey) => {
    if (contacts.length <= 1) return;
    const wasMain = contacts.find((r) => r._key === rowKey)?.isMain;
    const next = contacts.filter((row) => row._key !== rowKey);
    if (wasMain && next.length && !next.some((r) => r.isMain))
      next[0].isMain = true;
    onChange(next);
  };

  return (
    <div>
      <div className={classes.sectionHeading}>
        Individuals
        <button
          type="button"
          className={clsx(classes.addRowButton, classes.headingAction)}
          onClick={addRow}
        >
          <AddIcon fontSize="inherit" /> Add another individual
        </button>
      </div>
      {contacts.map((row, index) => (
        <div key={row._key} className={classes.editorRow}>
          <div className={classes.editorRowHead}>
            <span className={classes.editorRowLabel}>
              Individual {index + 1}
            </span>
            <div className={classes.editorRowActions}>
              <A_Switch
                label="Main"
                labelPlacement="end"
                size="small"
                checked={Boolean(row.isMain)}
                onChange={() => setMain(row._key)}
              />
              <IconAction
                danger
                title="Remove Individual"
                icon={<DeleteIcon fontSize="small" />}
                disabled={contacts.length <= 1}
                onClick={() => removeRow(row._key)}
              />
            </div>
          </div>
          <div className={classes.editorGrid}>
            <A_TextField
              id={`contact-name-${row._key}`}
              label="Name *"
              className={classes.field}
              defaultValue={row.name}
              onChange={(e) => updateRow(row._key, "name", e.target.value)}
              fullWidth
              size="small"
              margin="none"
              variant="outlined"
            />
            <A_TextField
              id={`contact-role-${row._key}`}
              label="Role"
              className={classes.field}
              defaultValue={row.role}
              onChange={(e) => updateRow(row._key, "role", e.target.value)}
              fullWidth
              size="small"
              margin="none"
              variant="outlined"
            />
            <A_TextField
              id={`contact-email-${row._key}`}
              label="Email *"
              className={classes.field}
              defaultValue={row.email}
              onChange={(e) => updateRow(row._key, "email", e.target.value)}
              fullWidth
              size="small"
              margin="none"
              variant="outlined"
            />
            <A_TextField
              id={`contact-phone-${row._key}`}
              label="Phone *"
              className={classes.field}
              defaultValue={row.phone}
              onChange={(e) => updateRow(row._key, "phone", e.target.value)}
              fullWidth
              size="small"
              margin="none"
              variant="outlined"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

ContactRowsEditor.propTypes = {
  contacts: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ContactRowsEditor;
